export const PRIVACY_ICON_MAP = {
    Fingerprint: 'Fingerprint',
    ShieldCheck: 'ShieldCheck',
    CreditCard: 'CreditCard',
    Eye: 'Eye',
    Lock: 'Lock',
    Database: 'Database',
    UserCheck: 'UserCheck',
    Zap: 'Zap',
    Activity: 'Activity',
    Server: 'Server',
    Globe: 'Globe',
    Key: 'Key',
    ShieldAlert: 'ShieldAlert',
    AlertTriangle: 'AlertTriangle',
    FileText: 'FileText',
    LockKeyhole: 'LockKeyhole',
    Search: 'Search',
    Shield: 'Shield',
};

export const getHexColor = (colorClass) => {
    if (!colorClass) return '#00f0ff';
    if (colorClass.startsWith('#')) return colorClass;
    const map = {
        'text-cyber-blue': '#00f0ff',
        'text-cyber-purple': '#bd00ff',
        'text-cyber-pink': '#ff007a',
        'text-cyber-green': '#39ff14',
        'text-white': '#ffffff',
    };
    return map[colorClass] || '#00f0ff';
};

export const getSectionId = (prefix, section, idx) => `${prefix}-section-${section.num || idx + 1}`;

export const sortSections = (sections = []) =>
    [...sections].sort((a, b) => parseInt(a.num || 0, 10) - parseInt(b.num || 0, 10));
